<ion-content scrollbar class="space-map__container">
  <div class="space-map__breadcrumbs" *ngIf="!p.renderMobile">
    <app-breadcrumb></app-breadcrumb>
  </div>
  <div class="position-relative">
    <div
      class="display-flex ion-align-items-center ion-justify-content-between ion-margin-bottom"
    >
      <app-space-filter
        class="space-map__filters"
        [showFloorsWithPlan]="true"
        [spaceType]="spaceType.Parking"
        [events]="eventsSubject.asObservable()"
        [ngClass]="{ 'ion-hide': p.renderMobile }"
      ></app-space-filter>
      <ion-button (click)="onToggleFilter()" *ngIf="p.renderMobile">
        {{ "SPACE_MAP.SELECT_BUILDING_AND_FLOOR" | translate }}
      </ion-button>

      <span class="display-flex ion-align-items-center">
        <div class="margin-right-8">
          {{ "SPACE_MAP.SWICH_VIEW_TO" | translate }}
        </div>
        <ion-button
          (click)="onEnableMovingSpaces()"
          [disabled]="disableSpaceMapMovingButton"
          fill="outline"
        >
          <ng-container *ngIf="enableMovingSpace">
            {{ "SPACE_MAP.ASSIGNING_SPACES" | translate }}
          </ng-container>
          <ng-container *ngIf="!enableMovingSpace">
            {{ "SPACE_MAP.MOVING_SPACES" | translate }}
          </ng-container>
        </ion-button>
      </span>
    </div>

    <app-space-map
      [workingMode]="workingMode.EDIT"
      [enableMovingInput]="enableMovingSubject.asObservable()"
      (enableMovingSpacesButton)="enableMovingSpacesButton($event)"
    ></app-space-map>
  </div>
</ion-content>
